<template>
  <MainWrapper>
    <div class="categories mb-30">
      <div class="categories-lvl-1-wrapper">
        <div class="container">
          <div class="row pos-rel">
            <div class="col-lg-1 left" style="width:50px !important">
              <div class="categories-lvl-1-cont" v-if="lvl1Scrolled !== 666">
                <div class="categories-lvl-1">
                  <ul>
                    <li class="inline-block">
                      <div
                        class="category-lvl-1-item pointer category-lvl-1-next-btn"
                        @click="lvl1Scrolled--"
                      >
                        <font-awesome-icon
                          :icon="['fal', 'chevron-circle-left']"
                          class="mr-10 category-lvl-1-icon"
                        />
                        <!--span>Назад</span-->
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-11 mob-m-l-40" style="width:calc(100% - 100px)">
              <div class="categories-lvl-1-cont">
                <div class="categories-lvl-1">
                  <ul :style="{transform: `translateX(-${lvl1Scrolled * 100}px)`}">
                    <li
                      class="inline-block"
                      v-for="c in categories"
                      :key="c.id"
                      v-tooltip="{ content: c.name, placement: 'bottom-center' }"
                    >
                      <router-link
                        :to="`/masters?cat=${c.slug}`"
                        class="category-lvl-1-item mr-20 pointer"
                        :class="{ active: chosenCategory === c.slug }"
                      >
                        <!--font-awesome-icon :icon="['fal', c.fa_icon]" class="mr-10 category-lvl-1-icon" /-->
                        <span>{{ c.name }}</span>
                        <div class="arr-down" v-if="chosenCategory === c.slug"></div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-1 right" style="width:50px !important">
              <div class="categories-lvl-1-cont" v-if="lvl1Scrolled !== 666">
                <div class="categories-lvl-1">
                  <ul>
                    <li class="inline-block">
                      <div
                        class="category-lvl-1-item pointer category-lvl-1-next-btn"
                        @click="lvl1Scrolled++"
                      >
                        <font-awesome-icon
                          :icon="['fal', 'chevron-circle-right']"
                          class="mr-10 category-lvl-1-icon"
                        />
                        <!--span>Далее</span-->
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="categories-lvl-2-wrapper" v-if="chosenCategory">
        <div class="container">
          <div class="row">
            <div class="col-lg-1" v-if="lvl2Scrolled !== 0">
              <div class="categories-lvl-1-cont">
                <div class="categories-lvl-1">
                  <ul>
                    <li class="inline-block">
                      <div
                        class="category-lvl-1-item pointer category-lvl-2-next-btn"
                        @click="lvl2Scrolled = 0"
                      >
                        <font-awesome-icon
                          :icon="['fal', 'chevron-circle-left']"
                          class="mr-10 category-lvl-1-icon"
                        />
                        <span>Назад</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-11">
              <div class="categories-lvl-2-cont">
                <div class="categories-lvl-2">
                  <ul :style="{transform: `translateX(-${lvl2Scrolled}px)`}">
                    <li class="inline-block" v-for="c in childCategories" :key="c.id">
                      <router-link
                        :to="generateSublink(c.slug)"
                        class="category-lvl-2-item mr-20 pointer"
                        :class="{active: chosenChildCategory === c.slug}"
                      >
                        <span class="dark-body-text">{{ c.name }}</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-1">
              <div class="categories-lvl-1-cont" v-if="lvl2Scrolled === 0">
                <div class="categories-lvl-1">
                  <ul>
                    <li class="inline-block">
                      <div
                        class="category-lvl-1-item pointer category-lvl-2-next-btn"
                        v-if="childCategories.length > 8"
                        @click="lvl2Scrolled = 500"
                      >
                        <font-awesome-icon
                          :icon="['fal', 'chevron-circle-right']"
                          class="mr-10 category-lvl-1-icon"
                        />
                        <span>Ещё</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="single-master-page">
      <div class="container">
        <div class="row">
          <!-- <div class="col-lg-4">
                    <div class="white-panel spec-categories">
                        <div class="spec-categories-header mb-15">
                            <h4>Все специалисты</h4>
                            <span class="dark-body-text spec-count">{{ specCount }}</span>
                        </div>
                        <div class="very-light-gray-line mb-15"></div>
                        <div class="spec-categories-body">
                            <div class="spec-categories-single mb-15" v-for="cat in categories" :key="cat.id">
                                <div class="checkbox pressed mr-15">
                                    <font-awesome-icon class="checkbox-check" :icon="['fal', 'check']" />
                                </div>
                                <span class="dark-body-text">{{ cat.name }}</span>
                                <font-awesome-icon :icon="['fal', 'angle-right']" class="icon" />
                            </div>
                        </div>
                        <div class="very-light-gray-line mb-30"></div>
                        <Button type="blue" text="Показать результаты" />
                    </div>
          </div>-->
          <div class="col-lg-12">
            <div class="container-fluid no-p">
              <div class="row">
                <div class="col-lg-12">
                  <h2 class="mb-15" v-if="specialists.length">Специалисты нашего сервиса</h2>
                </div>
              </div>
              <div class="row" v-if="loading">
                <div class="col-lg-12 loader">
                  <Loader />
                </div>
              </div>
              <div v-else>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="mb-30">
                      <Paginator
                        :pages="pages"
                        v-if="pages > 1"
                        :current="page"
                        v-on:change-page="(p) => page = p"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4" v-for="spec in specialists" :key="spec.id">
                    <Specialist
                      :name="spec.full_name"
                      :rating="spec.rating"
                      :cats="spec.categories"
                      :state="false"
                      :address="'г. Бишкек'"
                      :img="spec.photo"
                      :slug="spec.slug"
                      :status="spec.opened_now"
                      :company="spec.company"
                      :reviewCount="spec.feeds_count"
                    />
                  </div>
                  <div v-if="!specialists.length" class="specialists-empty">
                    <h2>В данной категории нет специалистов</h2>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <Paginator
                      :pages="pages"
                      v-if="pages > 1"
                      :current="page"
                      @change-page="changePage"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
@import '../../styles/main.core.vars.styl';

.spec-categories {
  padding: 20px 60px 30px 20px;
}

.spec-categories-header {
  display: flex;

  .spec-count {
    margin: 0 0 0 auto;
    color: $gray_text;
  }
}

.spec-categories-single {
  display: flex;
  align-items: center;

  >.icon {
    margin-left: auto;
    font-size: 16px;
  }
}

.categories {
  margin-top: -30px;
}

.categories-lvl-1, .categories-lvl-2 {
  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-wrap: no-wrap;
    margin: 0;
    transition: 0.3s;
  }
}

.categories-lvl-1-wrapper {
  background: #fff;
}

.categories-lvl-2-wrapper {
  background: $black_text;
}

.category-lvl-1-item {
  display: flex;
  align-items: center;
  height: 50px;
  position: relative;
  transition: 0.3s;

  span {
    width: max-content;
  }

  &:focus, &.active, &:hover {
    text-decoration: none;
    color: cyan_dark_color;
  }
}

.category-lvl-2-item {
  display: flex;
  align-items: center;
  height: 37px;

  span {
    width: max-content;
    color: #fff;
  }

  &.active {
    span {
      color: $dark_gray_text;
    }
  }
}

.categories-lvl-1-cont, .categories-lvl-2-cont {
  overflow: hidden;
}

.category-lvl-1-icon {
  font-size: 20px;
}

.category-lvl-1-next-btn {
  .category-lvl-1-icon {
    color: cyan_dark_color;
  }

  span {
    color: cyan_dark_color;
  }
}

.category-lvl-2-next-btn {
  height: 37px;

  .category-lvl-1-icon {
    color: #fff;
  }

  span {
    color: #fff;
  }
}

.col-lg-1 {
  min-height: 0;
}

.arr-down {
  position: absolute;
  bottom: -2px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid $black_text;
  z-index: 4;
  left: 0;
  right: 0;
  margin: auto;
}

.specialists-empty {
  text-align: center;
}

@media screen and (max-width: 768px) {
  .pos-rel {
    position: relative;
  }

  .col-lg-1 {
    position: absolute;
  }

  .right {
    right: 0;
    top: 0;
  }

  .mob-m-l-40 {
    margin-left: 40px;
  }
}
</style>
<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import Specialist from "@/components/Specialist.vue";
import Paginator from "@/components/Paginator.vue";
import Loader from "@/components/Loader.vue";
import http from "@/methods/http.ts";

@Component({
  components: {
    MainWrapper,
    Button,
    Specialist,
    Paginator,
    Loader,
  },
})
export default class Specialists extends Vue {
  specialists = [];
  categories = [];
  childCategories = [];

  lvl1Scrolled = 0;
  lvl2Scrolled = 0;

  page = 1;
  pages = 0;

  specCount = 0;

  chosenCategory = "";
  chosenChildCategory = "";
  defaultCategory = "medicina";

  loading = true;

  @Watch("$route", { deep: true, immediate: true })
  onRouteChange() {
    this.loading = true;
    this.chosenCategory = this.$route.query.cat || "";
    this.chosenChildCategory = this.$route.query.subcat || "";
    this.page = 1;
    this.lvl2Scrolled = 0;

    this.getCategories();

    if (this.chosenCategory) {
      this.getChildCategories();
    }

    this.getSpecialists();
  }

  @Watch("page", { deep: true, immediate: true })
  onPageChange() {
    this.loading = true;
    this.getSpecialists();
  }

  generateSublink(slug) {
    return `/masters?cat=${this.chosenCategory}&subcat=${slug}`;
  }

  getSpecialists() {
    http("masters", "get", false, {
      page: this.page,
      page_size: 12,
      categories:
        this.chosenChildCategory || this.chosenCategory || this.defaultCategory,
    }).then((r) => {
      this.specialists = r.data.results;
      this.pages = Math.ceil(r.data.count / 12);
      this.specCount = r.data.count;
      setTimeout(() => (this.loading = false), 1000);
    });
  }

  getCategories() {
    http("categories/medicina/first_child", "get", false, {}).then((r) => {
      this.categories = r.data.children;
    });
  }

  getChildCategories() {
    http(
      `categories/${this.chosenCategory}/first_child`,
      "get",
      false,
      {}
    ).then((r) => {
      this.childCategories = r.data.children;
    });
  }

  paginateClickHandler() {
    console.log("clicked");
  }

  changePage(p) {
    this.page = p;
    console.log({ page: p });
    this.scrollTop();
  }

  scrollTop() {
    let currentScrollY = window.scrollY;
    const interval = setInterval(() => {
      if (currentScrollY <= 0) {
        clearInterval(interval);
      }
      currentScrollY -= 30;
      window.scroll(0, currentScrollY);
    });
  }

  mounted() {
    this.chosenCategory = this.$route.query.cat || "";
    this.chosenChildCategory = this.$route.query.subcat || "";

    this.getSpecialists();
    this.getCategories();

    if (this.chosenCategory) {
      this.getChildCategories();
    }
  }
}
</script>